import CartProductListItem from '@/app-theme/components/cart/CartProductListItem.vue'
import ProductDetailsDialog from '@/app-theme/components/product/ProductDetailsDialog.vue'
import ProductCommon from '@/app-core/mixins/product/productCommon'
import {clone} from '@/app-core/lib/utils/helper'
import {floatNumber, toLocaleUpperCase} from '@/app-core/lib/helpers'
import CartCommon from '@/app-core/mixins/cart/cartCommon'
import CartActions from '@/app-core/mixins/cart/cartActions'
import PaymentMinimumOrderWarning from '@/app-theme/components/payment/common/PaymentMinimumOrderWarning.vue'
import BrandSlider from '@/app-theme/views/home/BrandSlider.vue'
import {uniqueElements} from '@/app-core/lib/utils/array'
import QrCodeOrderData from '@/app-theme/components/common/QrCodeOrderData.vue'
import ScheduledOrder from '@/app-theme/components/cart/ScheduledOrder.vue'
import OrderTypeSelector from '@/app-theme/components/cart/OrderTypeSelector.vue'
import CartComponents from '@/app-core/mixins/cart/cartComponents'
import CartStoreMinimumOrderWarning from '@/app-theme/components/cart/CartStoreMinimumOrderWarning.vue'
import Translatable from '@/app-core/mixins/translatable'
import SmsServiceCommon from '@/app-core/mixins/services/smsServiceCommon'

export default {
  name      : 'CartDrawer',
  components: {
    CartStoreMinimumOrderWarning,
    OrderTypeSelector,
    ScheduledOrder,
    QrCodeOrderData,
    BrandSlider,
    PaymentMinimumOrderWarning,
    ProductDetailsDialog,
    CartProductListItem
  },
  directives: {},
  enums     : {},
  mixins    : [Translatable, CartComponents, CartCommon, CartActions, ProductCommon, SmsServiceCommon],
  props     : {
    navigationDrawer: {
      type    : Boolean,
      required: true
    },
    items: {
      type    : Array,
      required: true
    }
  },
  dataStore: {
    AppCart  : 'App.Cart',
    AppStores: 'App.Stores',
    AppType  : 'App.Type',
    StoreMenu: 'Store.Menu',
    StoreInfo: 'Store.Info'
  },
  data() {
    return {
      productDetailsDialogVisible: false
    }
  },
  computed: {
    recommendedStores() {
      const storesInCart = uniqueElements(this.cartProducts?.map(item => item.StoreId) || [])
      const stores = this.AppStores || []

      return stores.filter(store => !storesInCart.includes(store.Id) && !this.storeIsClosed(store))
    },

    navigationDrawerVisible: {
      get() {
        return this.navigationDrawer
      },
      set(val) {
        this.$emit('update:navigationDrawer', val)
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on('product:details-dialog', this.showProductDetailsDialog)
    this.$bus.$on('cart:queue:push', this.cartQueueStatusUpdate)
    this.$bus.$on('cart:queue:idle', this.cartQueueStatusUpdate)
    this.$bus.$on('cart:add-product', this.addProductToCart)
    this.$bus.$on('cart:quick-add-product', this.quickAddProductToCart)
    this.$bus.$on('cart:remove-product', this.removeProductFromCart)
    this.$bus.$on('cart:update-product', this.updateProductQuantityFromCart)
    this.$bus.$on('cart:update-order-type', this.cartUpdateOrderType)
    this.$bus.$on('cart:add-service', this.addServiceToCart)
    this.$bus.$on('cart:remove-service', this.removeServiceFromCart)
    this.$bus.$on('cart:get-data', this.cartGet)
    this.$bus.$on('cart:set-data', this.cartSetData)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('product:details-dialog', this.showProductDetailsDialog)
    this.$bus.$off('cart:queue:push', this.cartQueueStatusUpdate)
    this.$bus.$off('cart:queue:idle', this.cartQueueStatusUpdate)
    this.$bus.$off('cart:add-product', this.addProductToCart)
    this.$bus.$off('cart:quick-add-product', this.quickAddProductToCart)
    this.$bus.$off('cart:remove-product', this.removeProductFromCart)
    this.$bus.$off('cart:update-product', this.updateProductQuantityFromCart)
    this.$bus.$off('cart:update-order-type', this.cartUpdateOrderType)
    this.$bus.$off('cart:add-service', this.addServiceToCart)
    this.$bus.$off('cart:remove-service', this.removeServiceFromCart)
    this.$bus.$off('cart:get-data', this.cartGet)
    this.$bus.$off('cart:set-data', this.cartSetData)
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    floatNumber,

    quickAddProductToCart(product) {
      if (!product) return

      this.selectedProduct = product?.DetailsData ? clone(product.DetailsData) : clone(product)

      this.initProduct()
      if (!this.isRequiredOptionsValid()) {
        this.showProductDetailsDialog(clone(product))
        return
      }

      this.addProductToCart(this.selectedProduct)
    },

    addServiceToCart(service) {
      if (!service) return
      this.cartAddService(service)
    },

    removeServiceFromCart(service) {
      if (!service) return
      this.cartRemoveService(service)
    },

    addProductToCart(product) {
      if (!product) return
      this.cartAddProduct(product)
    },

    removeProductFromCart(product) {
      if (!product) return
      this.cartRemoveProduct(product)
    },

    updateProductQuantityFromCart(product) {
      if (!product) return
      this.cartUpdateProduct(product)
    },

    showProductDetailsDialog(product, editMode = false) {
      if (!product) return

      if (!editMode && product?.DetailsData) {
        const productItem = clone(product.DetailsData)
        productItem.ModifierRuns = 0
        this.selectedProduct = productItem
        this.productDetailsDialogEditMode = false
        this.productDetailsDialogVisible = true
      } else {
        this.productDetailsDialogEditMode = true
        this.cartProductOptions(clone(product))
      }
    },

    onCheckoutDetails() {
      this.$router.push({name: 'CheckoutDetails'})
      this.navigationDrawerVisible = false
    },

    onAddProductsClick() {
      if (this.$route.name !== 'Home') {
        this.$router.push({name: 'Home'})
      }

      this.navigationDrawerVisible = false
    },

    toggleNavigationDrawer() {
      this.navigationDrawerVisible = !this.navigationDrawerVisible
    }
  }
}
